import { events } from "./events"
import { info } from "./info"

export const user = {
  events,
  info,
}
